module.exports = __webpack_public_path__ + "img/logo_rectangle_white.bf77a6b9.png";